import { lazy } from "react";

const edit = lazy(() => import("./Edit").then(m => ({ default: m.OfficeLocationEdit })));
const list = lazy(() => import("./List").then(m => ({ default: m.OfficeLocationList })));
const create = lazy(() => import("./Create").then(m => ({ default: m.OfficeLocationCreate })));

export default { edit, list, create };
